export default __webpack_public_path__ + "static/media/mongodb.b43ea7a6.svg";